import type { Device, Document } from "@models";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { IconButton, Tooltip } from "@mui/material";
import { DocumentActionsMenu } from "src/components/DocumentActionsMenu";
import type { TemplateConfig } from "src/types";

type DocumentsNewActionDeviceOption = Pick<Device, "id" | "name">;

export type DocumentsNewActionProps = {
  currentDeviceId: string | null;
  devices: DocumentsNewActionDeviceOption[];
  documents: Document[];
  folderId: string | null;
  getTemplatesConfigForDevice?: (
    deviceId: string
  ) => TemplateConfig | undefined;
  templatesConfig?: TemplateConfig;
};

export const DocumentsNewAction = ({
  currentDeviceId,
  devices,
  documents,
  folderId,
  getTemplatesConfigForDevice,
  templatesConfig,
}: DocumentsNewActionProps) => {
  return (
    <DocumentActionsMenu
      deviceId={currentDeviceId}
      devices={devices}
      documents={documents}
      getTemplatesConfigForDevice={getTemplatesConfigForDevice}
      targetFolderId={folderId}
      templatesConfig={templatesConfig}
      renderTrigger={({
        ariaControls,
        ariaExpanded,
        ariaHasPopup,
        id,
        onClick,
        onMouseDown,
      }) => (
        <Tooltip title="New">
          <IconButton
            aria-controls={ariaControls}
            aria-expanded={ariaExpanded}
            aria-haspopup={ariaHasPopup ? "menu" : undefined}
            aria-label="New"
            edge="end"
            id={id}
            onClick={onClick}
            onMouseDown={onMouseDown}
            size="small"
            sx={{ color: "text.secondary" }}
          >
            <AddRoundedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    />
  );
};
